import React, { useEffect, useState } from "react";
import { Upload } from "antd";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

import InputField from "../../../components/auth/InputField";
import GradientButton from "../../../components/common/UI/GradientButton";
import apiInstance from "../../../services/apiService";
import { storageService } from "../../../services/storageService";

import "./index.scss";

const ProfileSetting = () => {
  const navigate = useNavigate();
  const [imageUrl, setImageUrl] = useState<string | null>(null);
  const [selectedFile, setSelectedFile] = useState<File | null>(null);
  const [loading, setLoading] = useState(false);
  const [name, setName] = useState("");

  const handleImageUpload = (file: File) => {
    const reader = new FileReader();
    reader.onload = (e) => {
      if (e.target?.result) {
        setImageUrl(e.target.result as string);
        setSelectedFile(file);
      }
    };
    reader.readAsDataURL(file);
    return false;
  };

  const handleSubmit = async () => {
    if (!name.trim()) {
      return toast.error("Full name is required");
    }

    setLoading(true);
    const url = `auth/signup2/complete/profile`;

    const formData = new FormData();
    formData.append("fullName", name);

    if (selectedFile) {
      formData.append("file", selectedFile);
    }

    try {
      await apiInstance.post(url, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      navigate("/");
    } catch (error: any) {
      toast.error(
        error.response?.data?.message ||
          error.message ||
          "Something went wrong",
      );
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const token = storageService.getAccessToken();
    if (!token) {
      navigate("/auth/login");
    }
  }, [navigate]);

  return (
    <div className="profile-setting-container">
      <Upload
        className="circular-upload"
        multiple={false}
        showUploadList={false}
        accept="image/*"
        beforeUpload={(file) => {
          const isImage = file.type.startsWith("image/");
          if (!isImage) {
            toast.error("Only image files are allowed.");
            return Upload.LIST_IGNORE;
          }
          return handleImageUpload(file);
        }}
      >
        <div className="upload-container">
          {imageUrl ? (
            <img src={imageUrl} alt="Profile" className="uploaded-image" />
          ) : (
            <span>
              Add <br /> photo
            </span>
          )}
        </div>
      </Upload>

      <div className="name-field">
        <label>Name</label>
        <InputField
          type="text"
          value={name}
          onChange={(e) => setName(e.target.value)}
          placeholder="Enter name"
          disabled={loading}
        />
      </div>

      <GradientButton onClick={handleSubmit} loading={loading}>
        Continue
      </GradientButton>
    </div>
  );
};

export default ProfileSetting;
